const AddNoteIconAddressBook = ({ width = 16, height = 16, color = '#6E6E73' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2555 8.45136L8.11719 14.5898V17.8711H11.3984L17.5368 11.7326C18.0493 11.22 18.0493 10.389 17.5368 9.87644L16.1117 8.45134C15.5991 7.93878 14.7681 7.93878 14.2555 8.45136Z"
        stroke={color}
        strokeWidth="1.6875"
      />
      <path d="M7.25 21.5938H20.75" stroke={color} strokeWidth="1.6875" />
    </svg>
  )
}

export default AddNoteIconAddressBook
